<div class="flex min-h-screen flex-col bg-background">
  <header class="border-b border-border">
    <div class="mx-auto flex max-w-[1152px] items-center justify-between px-6 py-4">
      <div class="flex items-center gap-2">
        <span class="logo">AP</span>
        <span class="font-semibold">AGW Agency Portal</span>
      </div>
      <div class="flex items-center gap-2">
        @if (registerAvailable) {
          <a class="btn btn-ghost btn-sm" routerLink="/register">Register</a>
        }
        <button type="button" class="btn btn-primary btn-sm" (click)="agencyLogin()">
          Sign in
        </button>
      </div>
    </div>
  </header>

  <main class="mx-auto w-full max-w-[1152px] flex-1 px-6 pt-24 pb-20">
    <div class="max-w-[720px]">
      <p class="m-0 text-sm font-medium text-primary">AGW Agency Portal</p>
      <h1 class="m-0 mt-3 text-4xl leading-[1.05] font-semibold tracking-tight md:text-5xl">
        The Control Panel for
        <br />
        the AGW Travel Sellers
      </h1>
      <p class="m-0 mt-4 text-lg leading-relaxed text-muted-foreground">
        Shop, book and service all your NDC content in one single platform — and manage your airline
        providers, partner apps and booking reports right here.
      </p>
      <div class="mt-8 flex flex-wrap gap-3">
        <button type="button" class="btn btn-primary btn-lg" (click)="agencyLogin()">
          Agency login
          <app-icon name="arrow-right" />
        </button>
        @if (registerAvailable) {
          <a class="btn btn-outline btn-lg" routerLink="/register">
            <app-icon name="building" />
            Register your agency
          </a>
        }
        <a class="btn btn-outline btn-lg" [href]="bpUrl" target="_blank" rel="noopener">
          Open BookingPad
        </a>
      </div>
    </div>

    <div class="mt-20 grid gap-6 [grid-template-columns:repeat(auto-fit,minmax(260px,1fr))]">
      <div class="rounded-lg border border-border bg-card p-6">
        <div class="chip"><app-icon name="plane" /></div>
        <h3 class="m-0 mt-4 text-base font-semibold">Airline providers</h3>
        <p class="m-0 mt-1 text-sm leading-normal text-muted-foreground">
          Turn NDC airlines on or off for your agents and check your agency IDs and PCCs.
        </p>
      </div>
      <div class="rounded-lg border border-border bg-card p-6">
        <div class="chip"><app-icon name="plug" /></div>
        <h3 class="m-0 mt-4 text-base font-semibold">Partner applications</h3>
        <p class="m-0 mt-1 text-sm leading-normal text-muted-foreground">
          Grant AGW API partners access to your airline content, and revoke it at any time.
        </p>
      </div>
      <div class="rounded-lg border border-border bg-card p-6">
        <div class="chip"><app-icon name="chart" /></div>
        <h3 class="m-0 mt-4 text-base font-semibold">Booking reports</h3>
        <p class="m-0 mt-1 text-sm leading-normal text-muted-foreground">
          Bookings, tickets, voids and expiries by provider, agent, app or agency — exportable by
          email.
        </p>
      </div>
    </div>
  </main>

  <footer class="border-t border-border">
    <div
      class="mx-auto flex max-w-[1152px] flex-wrap items-center justify-between gap-3 px-6 py-5 text-xs text-muted-foreground"
    >
      <span>© {{ year }} AirGateway. All rights reserved.</span>
      <div class="flex gap-5">
        <a
          class="text-muted-foreground"
          href="https://support.airgateway.com/"
          target="_blank"
          rel="noopener"
        >
          Help Center
        </a>
        <a class="text-muted-foreground" href="#" target="_blank" rel="noopener">Privacy Policy</a>
        <a
          class="text-muted-foreground"
          href="https://airgateway.com/tos/"
          target="_blank"
          rel="noopener"
        >
          Terms of Service
        </a>
      </div>
    </div>
  </footer>
</div>
